export default __webpack_public_path__ + "static/media/cryptokitties.70739170.svg";